import { ajax } from '../index'

/**
 * Product相关接口
 */
export default {
  // 获取商品详情数据
  getProductDetail(productID: number | string, options?: { withCookies?: string }) {
    return ajax.get('api', `/api/v1/product/detail/${productID}`, {}, options)
  },

  // 获取详情页 release-product 和 reviews（solr的数据）
  getProductScreen(productID: number | string) {
    return ajax.get('api', `/api/v1/product/detail/screen/${productID}`, {})
  },

  // afterpay页面，获取分类下排名前五的商品
  getCategoryProductTopFive() {
    return ajax.get('api', `/api/v1/product/list/top-five`, {})
  },

  // 获取customer reviews
  getCustomerReviews(params: any) {
    return ajax.get('api', `/api/v1/review/review`, params)
  },

  // 获取google reviews
  getGoogleReviews(params: any) {
    return ajax.get('api', `/api/v1/review/google-review`, params)
  },

  // 评论点赞
  addVoteUseful(params: any) {
    return ajax.post('api', `/api/v1/review/add-vote-useful`, params)
  },

  // 获取recommend
  getRanking() {
    return ajax.get('api', `/api/v1/recommended/ranking`, {})
  },

  // 获取HotSearch
  getHotSearch(params: any) {
    return ajax.get('api', `/api/v1/keyword/hot-search`, params)
  },

  // 获取侧边栏New Arrivals商品
  getRecommendProduct(categoryId: number | string) {
    return ajax.get('api', `/api/v1/recommended/products/${categoryId}`, {})
  },

  // 获取商品详情
  getDescription(goodsId: number | string) {
    return ajax.get('api', `/api/v1/product/description/${goodsId}`, {})
  },

  // 获取详情页中部推荐similar 商品
  getSimilar(productID: any) {
    return ajax.get('api', `/api/v1/recommended/similar/${productID}`, {})
  },

  // 获取商品是否有加入心愿单
  getIsWishByProduct(productID: any) {
    return ajax.get('api', `/api/v1/wishlist/is/${productID}`, {})
  },

  // 加入心愿单
  addWishList(params: any) {
    return ajax.post('api', `/api/v1/wishlist/add`, params)
  },

  // 加入心愿单
  removeWishList(productID: any) {
    return ajax.delete('api', `/api/v1/wishlist/${productID}`, {})
  },

  // 中部banner图片
  minitopBanner() {
    return ajax.get('api', `/api/v1/banner/mini-top`, {})
  },

  // 获取默认postcode
  getDefaultPostcode() {
    return ajax.get('api', `/api/v1/shipping/default-postcode`, {})
  },

  // 获取suburb列表
  getSuburbByPostcode(params: any) {
    return ajax.get('api', `/api/v1/shipping/suburb-state`, params)
  },

  // 获取邮费信息
  getShippingData(params: any) {
    return ajax.get('api', `/api/v1/shipping`, params)
  },

  // 批发佬提交
  wholesale(params: any) {
    return ajax.post('api', `/api/v1/product/wholesale`, params)
  },

  // notify me
  addNotify(params: any) {
    return ajax.post('api', `/api/v1/product/add-notice`, params)
  },

  // 详情旁边广告
  detailRightBox() {
    return ajax.get('api', `/api/v1/banner/detail-right-box`, {})
  },

  // 获取找更多
  getFineMore(productID: string | number) {
    return ajax.get('api', `/api/v1/product/tag/${productID}`, {})
  },

  // 获取notify验证码
  generate() {
    return ajax.get('api', `/api/v1/captcha/generate`, {})
  },

  // 获取组合商品
  combine(productId: string | number | undefined) {
    return ajax.get('api', `/api/v1/product/combine/${productId}`, {})
  },

  // 获取组合商品总价
  combineCalculate(productList: Array<{ productID: number }>) {
    return ajax.post('api', `/api/v1/product/combine/calculate`, productList)
  },

  // 商品评论页检查
  reviewCheck(params:any) {
    return ajax.get('api', `/api/v1/review/check`, params)
  },

  // 保存评论
  reviewSave(params:any) {
    return ajax.post('api', `/api/v1/review/save`, params)
  }
}